import React, { useState } from "react";

const COMPONENT_CLASS = "c-generate-partner-api-key-tool";

const GeneratePartnerApiKeyTool: React.FC = () => {
    const [partnerId, setPartnerId] = useState("");
    const [apiKey, setApiKey] = useState("");
    const [copied, setCopied] = useState(false);

    const generateSecureKey = () => {
        if (!partnerId.trim()) return;

        const array = new Uint8Array(32);
        window.crypto.getRandomValues(array);

        // Convert to base64url
        const base64 = btoa(String.fromCharCode(...array))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        const key = `${partnerId.trim()}_${base64}`;
        setApiKey(key);
        setCopied(false);
    };

    const copyToClipboard = async () => {
        if (!apiKey) return;
        await navigator.clipboard.writeText(apiKey);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className={COMPONENT_CLASS} style={{ maxWidth: 500 }}>
            <h3>Generate Partner API Key</h3>

            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <input
                    type="text"
                    placeholder="Enter partnerId"
                    value={partnerId}
                    onChange={(e) => setPartnerId(e.target.value)}
                    style={{ padding: 8 }}
                />

                <button onClick={generateSecureKey}>
                    Generate API Key
                </button>

                {apiKey && (
                    <div style={{ marginTop: 10 }}>
                        <label>Generated API Key:</label>
                        <div style={{
                            display: "flex",
                            gap: 8,
                            marginTop: 4
                        }}>
                            <input
                                type="text"
                                value={apiKey}
                                readOnly
                                style={{ flex: 1, padding: 8 }}
                            />
                            <button onClick={copyToClipboard}>
                                {copied ? "Copied!" : "Copy"}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GeneratePartnerApiKeyTool;